<template>
  <div class="page-content">
    <page-template ref="returnTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower'
  import date from '@/mixin/date'

  export default {
    mixins: [userPower, date],
    components: {
      pageTemplate,
    },
    data() {
      return {
        listShow: false,
        goodList: [],
        dialogShow: false,
        dialogVisibility: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '请输入业务单号',
              prop: 'orderNo',
              type: 'input',
              ifFuzzy: true,
              placeholder: "请输入业务单号"
            },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24
            },
            {
              label: '门店',
              type: 'select',
              prop: 'storeId',
              span: 12,
              isHasAll: true,
              data: [],
              url: api.store.store,
            },
            // {
            //   label: '批发客户编码',
            //   prop: 'wholesaleCustomerCode',
            //   type: 'input',
            //   span: 12,
            //   ifFuzzy: true,
            //   placeholder: "请输入批发客户编码,模糊匹配"
            // },
            {
              label: "批发客户",
              type: "select",
              prop: "wholesaleCustomerId",
              data: [],
              url: api.wholesale.archives,
              span: 12,
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              type: 'select',
              defaultValue: 20,
              data: [{label: '未审核', value: 20}, {label: '已审核', value: 10}],
              span: 12
            },
          ]
        },
        // 更多功能
        toolConfig: [
          {
            label: '新增',
            code: 'insert',
            callback: this.addRequisition
          },
          {
            label: '打印',
            code: 'print',
            filter: () => {
              return false
            }
          },
          {
            label: '导出',
            code: 'export',
            callback: this.goodsDetailExport,
            filter: () => {
              return false
            }
          },
          {
            label: '编辑',
            type: this.$utils.buttonType.tableOperate,
            code: 'update',
            callback: this.toEditPage,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
          {
            label: '删除',
            code: 'delete',
            type: this.$utils.buttonType.tableOperate,
            filter: (data) => {
              return data.reviewerStatus == 10 ? false : true;
            }
          },
        ],
        // 表格信息配置
        tableOptions: {
          tableName: 'clearTable',
          showSelect: true,
          indexShow: true,//是否显示索引
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
              width: '230',
              align: 'center',
              //showDetail: true
              callback: this.goOrderDetail
            },
            {label: '客户编码', prop: 'wholesaleCustomerCode', width: '150', align: 'center'},
            {label: '客户名称', prop: 'wholesaleCustomerName', width: '150', align: 'center'},
            {
              label: "仓库",
              prop: "warehouseName",
              width: '200', align: 'center',
            },
            {
              label: '审核状态',
              prop: 'reviewerStatus',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('wlWholesaleReturnOrder.reviewerStatus')
            },
            // {label: '经手人姓名', prop: 'salesman', width: '150', align: 'center'},
            {label: '单据金额', prop: 'totalAmt', width: '100', align: 'center'},

            {label: '制单人', prop: 'voucherName', width: '150', align: 'center'},
            {label: '制单日期', prop: 'voucherDttm', width: '150', align: 'center'},
            {label: '审核人', prop: 'reviewerName', width: '120', align: 'center',},
            {label: '审核日期', prop: 'reviewerDttm', width: '150', align: 'center',},
            {label: '备注', prop: 'remarks', width: '120', align: 'center',},
          ],
          param: {reviewerStatus: 20, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
          url: api.wholesale.wholesaleReturn
        },
        detailColumns: {
          statusOption: {
            prop: 'reviewerStatus',
            statusImg: {
              10: '/static/checked.png',
              20: '/static/un-check.png'
            },
            right: '100px',
            top: '0',
          },
          span: 8,
          labelWidth: "130",
          columns: [
            {
              label: '业务单号',
              prop: 'orderNo',
            },
            {
              label: "批发门店",
              prop: "storeName",
            }, {
              label: '批发客户',
              prop: 'wholesaleCustomerName',
            }, {
              label: "仓库",
              prop: "warehouseName",
            }, {
              label: '经手人',
              prop: 'salesman',
            },
            {
              label: '批发销售单',
              type: 'select',
              prop: 'wholesaleOrderNo',
            }, {
              label: '备注',
              prop: 'remarks',
            }],
          tablesProp: {
            wlWholesaleOrderGoodsMapList: {
              url: api.wholesale.wholesaleQuery + "/page",
              height: this.detailHeight,
              indexShow: true,
              showSummary: true,
              tableName: "wlWholesaleOrderGoodsMapList",
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  type: 'inputNumber',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            }
          },

          // 打印的列表
          printTablesProp: {
            wlWholesaleOrderGoodsMapList: {
              tableName: 'wlWholesaleOrderGoodsMapList',
              showSummary: true,
              summaryColumns: ['goodsCount', 'giveGoodsCount', 'discountAmt'],
              columns: [
                {
                  label: '条码',
                  prop: 'barCode',
                  width: '180',
                  align: "center"
                },
                {
                  label: "商品名称",
                  prop: "goodsName",
                  width: '120',
                  align: "center"
                },
                {
                  label: "规格",
                  prop: "specs",
                  width: '90',
                  align: "center"
                },
                {
                  label: '单位',
                  width: '90',
                  prop: 'unitName',
                  align: "center"
                },
                {
                  label: '自编码',
                  width: '125',
                  prop: 'artNo',
                  align: "center"
                },
                {
                  label: '数量',
                  width: '90',
                  prop: 'goodsCount',
                  type: 'inputNumber',
                  align: "center"
                },
                {
                  label: '赠送数量',
                  width: '90',
                  prop: 'giveGoodsCount',
                  align: "center"
                },
                {
                  label: '原价',
                  width: '90',
                  prop: 'beforePrince',
                  align: "center"
                },
                {
                  label: '原价金额',
                  width: '90',
                  prop: 'beforeAmt',
                  align: "center"
                },
                {
                  label: '折扣',
                  width: '90',
                  prop: 'discountRate',
                  align: "center"
                },
                {
                  label: '折扣价格',
                  width: '90',
                  prop: 'discountPrince',
                  align: "center"
                },
                {
                  label: '小计金额',
                  width: '90',
                  prop: 'discountAmt',
                  align: "center"
                },
                {
                  label: '系统库存',
                  width: '90',
                  prop: 'inventoryNum',
                  align: "center"
                },
                {
                  label: '备注',
                  prop: 'remarks',
                  width: '90',
                  align: "center"
                },
              ],
            },
          },
          url: api.wholesale.wholesaleReturn
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.complex)
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
      }
      this.$nextTick(() => {
        this.tableOptions.url = api.wholesale.wholesaleReturn
        this.$refs['returnTemplate'].operationSuccess();
      })
    },
    methods: {
      goOrderDetail(row) {
        this.$utils.setDataByKey(this.$utils.storeKeys.FORMINFO, this.detailColumns);
        this.$router.push({
          path: '/wholeasle/return/detail?id=' + row.id,
          query: {redirect: '/wholeasle/return'}
        }).catch(err => {
        });
      },
      toEditPage(row) {
        this.$router.push({path: '/wholeasle/return/add?id=' + row.id});
      },
      addRequisition() {
        this.$router.push({path: '/wholeasle/return/add'});
      },
      goodsDetailExport() {
        let selectData = this.$refs["returnTemplate"].$refs["tableTemp"].selectRow;
        if (selectData.length === 0) {
          this.$confirm('请选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } else {
          if (selectData.length > 1) {
            this.$confirm('只能选择一条数据！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.$refs["returnTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
            })
          } else {
            this.$axios.fetchPost(api.wholesale.returnExport, {
              orderNo: selectData[0].orderNo,
              exportCode: 'WlWholesaleReturnExport'
            }).then(data => {
              if (data.code === 200) {
                const elink = document.createElement('a');
                elink.href = data.data;
                elink.click();
                this.loadingExt = false;
                this.$notify({
                  type: "success",
                  title: '导出操作',
                  message: '成功',
                  showClose: false,
                });
                // this.$message({message: '导出成功', type: 'success'});
              } else {
                this.$notify({
                  type: "error",
                  title: '导出操作',
                  message: '失败',
                  showClose: false,
                });
                // this.$message({message: '导出异常', type: 'error'});
              }
            })
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/wholeasle/return.vue